import {
  DispatchIcon,
  EntitiesIcon,
  InventoryIcon,
  Operations as OperationsIcon,
  ToolsIcon,
} from '@returnmates/ui-core/src/components/imageComponents/sidebarIcons/'

import DashboardIcon from '../components/images/icons/dashboard'
import { SECTIONS } from '../components/Sidebar/constants'
import { MAIN, PACKAGE_LOG, PARTNERS, QR, ROUTES, USERS } from './paths'

const sidebarItems = [
  {
    icon: DashboardIcon,
    path: MAIN,
    section: SECTIONS.DASHBOARD,
  },
  {
    icon: DispatchIcon,
    path: ROUTES,
    section: SECTIONS.DISPATCH,
  },
  {
    icon: InventoryIcon,
    path: PACKAGE_LOG,
    section: SECTIONS.INVENTORY,
  },
  {
    icon: EntitiesIcon,
    path: USERS,
    section: SECTIONS.ENTITIES,
  },
  {
    icon: ToolsIcon,
    path: QR,
    section: SECTIONS.TOOLS,
  },
  {
    icon: OperationsIcon,
    path: PARTNERS,
    section: SECTIONS.OPERATIONS,
  },
]

export default sidebarItems
